import { HIDE_SENSITIVE_MODAL, SHOW_SENSITIVE_MODAL } from './constants';

export const showSensitiveModal = typeModal => dispatch => {
  dispatch({
    type: SHOW_SENSITIVE_MODAL,
    payload: typeModal,
  });
};

export const hideSensitiveModal = () => dispatch => {
  dispatch({
    type: HIDE_SENSITIVE_MODAL,
  });
};
